import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'wsb-grid-selectfilter-renderer',
  template: `
    <select (change)="onChange($event.target.value)" [(ngModel)]="select" class="form-control" *ngIf="!hide">
      <ng-container *ngFor="let option of options">
        <option *ngIf="!option.notranslate" value="{{ option.value }}">{{ option.label | translate }}</option>
        <option *ngIf="option.notranslate" value="{{ option.value }}">{{ option.label }}</option>
      </ng-container>
    </select>
  `,
  standalone: false
})
export class SelectfilterRendererComponent implements ICellRendererAngularComp {
  params;
  options;
  select;
  onChange;
  hide = false;

  agInit(params): void {
    this.params = params;
    this.hide = this.params.hide && this.params.hide instanceof Function ? this.params.hide(params) : false;
    this.options = this.params.options ? this.params.options() : null;
    const selval = this.params.select ? this.params.select() : null;
    this.select = selval ? selval : this.options && this.options.length ? this.options[0].value : null;
    this.onChange = this.params.onChange;
    if (this.params.afterLoad) {
      this.params.afterLoad(this.select);
    }
    // this.onChange(this.select);
  }

  refresh(params: any): boolean {
    return false;
  }
}
